module.exports = __webpack_public_path__ + "img/japan-ill-defined-causes-female.3595c36f.png";